(function() {
	'use strict';

	angular.module('quantixApp').factory('localStorage', localStorage);
	localStorage.$inject = [ '$resource' ];
	function localStorage($resource) {
		return {};
	}

	angular.module('quantixApp').controller('RenewableEnergyDetailsController',
			RenewableEnergyDetailsController);

	RenewableEnergyDetailsController.$inject = [ '$scope', 'Principal',
			'$state', '$stateParams', 'renewableEnergyService',
			'GenericServiceNew', 'ivhTreeviewBfs', '$timeout',
			'ivhTreeviewOptions', 'ErrorHandlerService', '$uibModal', '$http',
			'$window', '$rootScope','GenericService' ];

	function RenewableEnergyDetailsController($scope, Principal, $state,
			$stateParams, renewableEnergyService, GenericServiceNew,
			ivhTreeviewBfs, $timeout, ivhTreeviewOptions, ErrorHandlerService,
			$uibModal, $http, $window, $rootScope,GenericService) {

		$scope.previousRatingText = "Add";
		var gridData = '';
		$scope.modal = {
			selectedHolding : "",
			selectedSpv : ""
		}
		$scope.isFinancial = false;
		var vm = this;
		vm.modelName = $stateParams.modelName;
		vm.data = $stateParams.data;
		$scope.selectedFilter = JSON.parse($stateParams.selectedFilter);
		console.log($scope.selectedFilter);
		if ($scope.selectedFilter.allocationId == 1) {
			vm.modelName = "Tendered";
		} else {
			vm.modelName = "Allocation";
		}
		$scope.exportflag = '';
		$scope.modelNameKey = vm.modelName;

		if (vm.data == null) {
			$state.go('renewableEnergy');
		}

		$scope.gridDataForBotToll = {
			dataProvider : vm.data,
			delegate : $scope
		};

		$scope.gridDataForBotToll;
		$scope.exportFlag = false;

		$scope.getDate = function(rowData,column) {
			var param = column.dataField;
			var val = rowData[param];
			var re = new RegExp("^[a-zA-Z ]+$");
			if(val!=null && !re.test(val)) {
				var arr = val.split("-");
				val = arr[1]+"-"+arr[2];
			}
			return val;
		}

		$scope.setHeaderText = function(rowData, column) {
			var plfYearObject = {
				'plfValue1': 'fiscalYear1',
				'plfValue2': 'fiscalYear2',
				'plfValue3': 'fiscalYear3',
			};
			var param = column.dataField;
			var headerVal = rowData[plfYearObject[param]];
			// headerVal = headerVal.toString().replace("20","FY");
			column._headerText = "PLF "+headerVal;
			var val = rowData[param];
			return val;
		}

		$scope.botTollListGridCompletion = function(event) {
			gridData = event.target;
			gridData.validateNow();
			$("#gridForBotToll_btnSettings img").attr('title','Select columns');
			$("#gridForBotToll2_btnSettings img").attr('title','Select columns');
			$("#gridForBotToll3_btnSettings img").attr('title','Select columns');
			$("#gridForBotToll4_btnSettings img").attr('title','Select columns');
			
		};

		$scope.gotolandingpage = function() {
			$state.go('renewableEnergy');
		}
		$scope.userSectionAccessData = GenericService.getUserSectionAccessData();

		GenericService.getUserModuleAccessData().then(function(result){
			GenericService.getUserSectionAccessData().then(function (result) {
                $scope.userSectionAccessData = result;
				if (!(($scope.userSectionAccessData["INFRASTRUCTURE.Renewables"] == "Y") || ($scope.userSectionAccessData["INFRASTRUCTURE.Renewables_Trial"] == "Y"))) {
					ErrorHandlerService.forbiddenError("Renewable Energy");
					return;
				}
				if ($scope.userSectionAccessData["INFRASTRUCTURE.Renewables"] == "Y") {
					$scope.exportFlag = true;
				}
            });
			if (!result["INFRASTRUCTURE"]) {
				ErrorHandlerService.forbiddenError("INFRASTRUCTURE");
				return;
			}
		});
		
		$scope.addORRemoveFun = function() {
			if($scope.previousRatingText == "Add") {
				$scope.isFinancial = true;
				$scope.previousRatingText = "Remove";
				$("#addFinancialId div.radio-inline").removeClass("hidden");
				if($("#addFinancialId div input[type='radio']:checked").length> 0) {
					$scope.addfincancialData();
				} else {
					$scope.selectedvalue = "spv";
					$("#addFinancialId div input[type='radio'][value='spv']").prop("checked", true);
					$scope.addfincancialData();
				}
			} else if($scope.previousRatingText == "Remove") {
				$scope.isFinancial = false;
				$scope.previousRatingText = "Add";
				$("#addFinancialId div.radio-inline").addClass("hidden");
			}
		}

		$scope.selectedvalue = "";
		$scope.addFinancial = function(ele) {
			if (ele.target.type == 'radio') {
				var radioVal = $("#addFinancialId input.addFinancial:checked")
						.val();
				if ($scope.selectedvalue != radioVal) {
					$scope.selectedvalue = radioVal;
					$scope.addfincancialData();
				}
			} else {
				return false;
			}
		}

		$scope.addfincancialData = function() {
			$scope.selectedFilter['addFinancial'] = $scope.selectedvalue;
			renewableEnergyService.getProjectDataMapForSelection(JSON.stringify($scope.selectedFilter)).then(function(data) {
				$scope.gridDataForBotToll1 = {
					dataProvider : data[Object.keys(data)[0]],
					delegate : $scope
				};
			}, function(errordata) {

			});
		}

		$scope.downloadDataInExcel = function() {
			if ($scope.selectedFilter != undefined) {
				if(!$scope.isFinancial) {
					$scope.selectedFilter['addFinancial'] = null;
				}
				$scope.selectedFilter['downloadFlag'] = false;
				$http(
						{
							url : 'api/infrastructureProjects/exportExcelRenewableData',
							method : 'POST',
							data : $scope.selectedFilter,
							responseType : 'arraybuffer'
						})
						.success(

								function(response) {

									var isIE = false || !!document.documentMode;
									$scope.response = response;
									var blob = new Blob(
											[ response ],
											{
												type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
											});
									if (isIE) {

										window.navigator
												.msSaveOrOpenBlob(blob,
														'Infrastructure Project Report_New.xlsx');
									} else {

										var anchor = angular.element('<a/>');
										var blob = new Blob([ response ], {
											type : 'application/vnd.ms-excel'
										})
										var objectUrl = (window.URL || window.webkitURL)
												.createObjectURL(blob);
										anchor.css({
											display : 'none'
										});
										// Make sure it's not visible
										angular.element(document.body).append(
												anchor); // Attach to
										// document
										anchor
												.attr({
													href : objectUrl,
													target : '_self',

													download : 'Infrastructure Project Report.xlsx'
												})[0].click();

										anchor.remove();

									}

								})

			} else {
				alert("Please click on Display Data before Exporting Data  ");
			}
		}
	}
})();